<template>
  <b-col
    :cols="smCols"
    :md="mdCols"
  >
    <component
      :is="component"
      v-for="{ _uid, component, ...props } in content"
      :key="_uid"
      v-editable="props"
      v-bind="props"
    />
  </b-col>
</template>

<script>

import AppRichtext from '@/components/blocks/AppRichtext'

export default {
  name      : 'AppColumn',
  components: { AppRichtext },
  props     : {
    content: { type: Array, default: null },
    smCols : { type: String, default: null },
    mdCols : { type: String, default: null },
  },
}
</script>
